/**
 * Quick Links — click handlers for hero quick-link actions.
 *
 * "near-me": reads geo cache from localStorage.
 * - If user is in US → navigate with ?q={location}
 * - If not US or no data → plain /search/results
 *
 * Location priority:
 *  1. userLocation  — "Financial District, NY" (detected city from autocomplete dropdown)
 *  2. postal code   — "10065" (ZIP from IP geolocation)
 *  3. city + region  — "New York City, NY" (raw geo API data)
 */

const GEO_CACHE_KEY = "campsNearYou_geoLocation_v5";
//add comment for redeploy environment

/**
 * Extract best available location string from geo cache
 */
function getLocationFromCache(geo) {
  // 1. Exact string shown in autocomplete dropdown
  if (geo.userLocation) return geo.userLocation;

  // 2. ZIP code (unambiguous)
  const postal = geo.coords?.postal || geo.realLocationData?.postal || "";
  if (postal) return postal;

  // 3. Build "City, ST" from geo data
  const city = geo.city || geo.realLocationData?.city || "";
  const region = geo.regionCode || geo.realLocationData?.regionCode || "";
  if (city && region) return `${city}, ${region}`;
  if (city) return city;

  return "";
}

const ACTIONS = {
  /**
   * Camps near me: navigate to search with detected US location
   */
  "near-me"(event, link) {
    try {
      const cached = localStorage.getItem(GEO_CACHE_KEY);
      if (!cached) return; // No geo data — default href

      const geo = JSON.parse(cached);

      // Only enrich URL for US users
      const isUS = geo.realLocationData?.isUS ?? geo.coords?.isUS ?? false;
      if (!isUS) return; // Not US — default href (/search/results)

      const location = getLocationFromCache(geo);
      if (!location) return;

      event.preventDefault();
      const url = new URL(link.href, window.location.origin);
      url.searchParams.set("q", location);
      window.location.href = url.toString();
    } catch (e) {
      // localStorage unavailable or parse error — fall through to default href
    }
  },
};

function init() {
  document.addEventListener("click", (e) => {
    const link = e.target.closest("[data-quick-action]");
    if (!link) return;

    const action = link.dataset.quickAction;
    if (ACTIONS[action]) {
      ACTIONS[action](e, link);
    }
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
